<template>
	<div class="announcement_wrap">
		<section class="announcement_form">
			<form @submit.prevent="createCustomer()">
				<div class="row">
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="Phone"
							label="Mobile Number"
							type="number"
							v-model="data.phone"
							class="form-control form-control-lg dashInput"
							rules="required|min:9|max:10"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="Email"
							label="Email"
							type="email"
							v-model="data.email"
							class="form-control form-control-lg dashInput"
							rules="email"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<div class="row">
							<div class="form-group col-sm-4">
								<BaseMultiSelect
									@update:value="setSalutation"
									:options="multiSelectState.salutations"
									:defaultData="data.salutation"
									rules="required"
									:required="true"
									name="Salutation"
								/>
							</div>
							<div class="form-group col-sm-8">
								<BaseInput
									name="First Name"
									label="First Name"
									type="text"
									v-model="data.firstName"
									class="form-control form-control-lg dashInput"
									rules="required|min:3|max:20"
									:required="true"
								/>
							</div>
						</div>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="Last Name"
							label="Last Name"
							type="text"
							v-model="data.lastName"
							class="form-control form-control-lg dashInput"
							:required="true"
							rules="required|min:3|max:20"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="Address"
							label="Address"
							type="text"
							class="form-control form-control-lg dashInput"
							v-model="data.loc"
							rules="required|min:10|max:200"
						/>
					</div>
					<div class="form-group col-sm-3 mb-4">
						<BaseInput
							name="city"
							label="City"
							type="text"
							v-model="data.city"
							class="form-control form-control-lg dashInput"
							rules="required|min:3|max:50"
						/>
					</div>
					<div class="form-group col-sm-3 mb-4">
						<BaseInput
							name="Postal Code"
							label="Postal Code"
							type="number"
							v-model="data.postalCode"
							class="form-control form-control-lg dashInput"
							rules="required|min:6|max:6"
							:min="100000"
							:max="999999"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="Alternate Phone"
							label="Alternate Mobile Number"
							type="text"
							v-model="data.alternatePhone"
							class="form-control form-control-lg dashInput"
							rules="min:10|max:10"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="Alternate Phone One"
							label="Alternate Phone One"
							type="text"
							v-model="data.alternatePhoneOne"
							class="form-control form-control-lg dashInput"
							rules="min:10|max:10"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="Alternate Phone"
							label="Alternate Mobile Number"
							type="text"
							v-model="data.alternatePhoneTwo"
							class="form-control form-control-lg dashInput"
							rules="min:9|max:10"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="Alternate Email"
							label="Alternate Email"
							type="email"
							v-model="data.alternateEmail"
							class="form-control form-control-lg dashInput"
							rules="email"
							@required="true"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="Date Of Birth"
							label="Date Of Birth"
							type="date"
							v-model="data.dateOfBirth"
							class="form-control form-control-lg dashInput"
							rules="required"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="Anniversary"
							label="Anniversary"
							type="date"
							v-model="data.anniversary"
							class="form-control form-control-lg dashInput"
							rules="required"
						/>
					</div>

					<div class="form-group col-sm-6 mb-4">
						<BaseMultiSelect
							@update:value="setCustomerType"
							:defaultData="data.customerType"
							:options="multiSelectState.customerType"
							rules="required"
							name="Customer Type"
						/>
					</div>

					<div class="form-group col-sm-6 mb-4">
						<BaseMultiSelect
							@update:value="setTag"
							:options="multiSelectState.tagsSelect"
							:defaultData="data.tags"
							:closeOnSelect="false"
							rules="required"
							name="Tags"
							mode="multiple"
						/>
					</div>

					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="Address One"
							label="Address One"
							type="text"
							v-model="data.addressOne"
							class="form-control form-control-lg dashInput"
							rules="required|min:3"
						/>
					</div>

					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="Alternate Address"
							label="Alternate Address"
							type="text"
							v-model="data.alternateAddress"
							class="form-control form-control-lg dashInput"
							rules="required|min:3"
						/>
					</div>
					<!-- <div class="col-sm-12">
						<h3>Select an identity proof</h3>
					</div>
					<div class="form-group col-sm-3 mt-4 mb-4 d-flex align-items-center">
						<BaseRadio
							class="form-check-input m-0"
							labelClass="small"
							label="Pan Card"
							id="panCard"
							name="IdentityProof"
							v-model="data.identityProof"
						/>
					</div>
					<div class="form-group col-sm-3 mt-4 mb-4 d-flex align-items-center">
						<BaseRadio
							class="form-check-input m-0"
							labelClass="small"
							label="Aadhar Card"
							id="aadharCard"
							name="IdentityProof"
							v-model="data.identityProof"
						/>
					</div>
					<div class="form-group col-sm-3 mt-4 mb-4 d-flex align-items-center">
						<BaseRadio
							class="form-check-input m-0"
							labelClass="small"
							label="Passport"
							id="Passport"
							name="IdentityProof"
							v-model="data.identityProof"
						/>
					</div>
					<div class="form-group col-sm-3 mt-4 mb-4 d-flex align-items-center">
						<BaseRadio
							class="form-check-input m-0"
							labelClass="small"
							label="Driving License"
							id="drivingLicense"
							name="IdentityProof"
							v-model="data.identityProof"
						/>
					</div>
					<div v-if="data.identityProof" class="col-sm-12">
						<div class="form-check form-switch mt-2 mb-4">
							<input
								class="form-check-input"
								v-model="imageDocument"
								type="checkbox"
								id="imageCheck"
							/>
							<label class="form-check-label text-dark" for="imageCheck"
								>Upload Document image</label
							>
						</div>
						<BaseImageUpload
							v-if="imageDocument"
							urlParam="customers"
							@images-data="setImage"
						/>
					</div>
					<div v-if="data.identityProof === 'Pan Card'" class="row">
						<div class="form-group col-sm-6 mb-4">
							<BaseInput
								name="Pan Number"
								label="Pan Number"
								type="text"
								v-model="panCard.number"
								class="form-control form-control-lg dashInput"
								rules="required|min:3"
							/>
						</div>
					</div>
					<div v-if="data.identityProof === 'Aadhar Card'" class="row">
						<div class="form-group col-sm-6 mb-4">
							<BaseInput
								name="Aadhar Number"
								label="Aadhar Number"
								type="number"
								v-model="aadharCard.number"
								class="form-control form-control-lg dashInput"
								rules="required|min:12|max:12"
								min="100000000000"
								max="999999999999"
							/>
						</div>
					</div>
					<div v-if="data.identityProof === 'Driving License'" class="row">
						<div class="form-group col-sm-3 mb-4">
							<BaseInput
								name="DL Number"
								label="DL Number"
								type="text"
								v-model="drivingLicense.number"
								class="form-control form-control-lg dashInput"
								rules="required|min:3"
							/>
						</div>

						<div class="form-group col-sm-3 mb-4">
							<BaseInput
								name="DL Issue Date"
								label="DL Issue Date"
								type="date"
								v-model="drivingLicense.issueDate"
								class="form-control form-control-lg dashInput"
								rules="required"
							/>
						</div>
						<div class="form-group col-sm-3 mb-4">
							<BaseInput
								name="DL Expiry Date"
								label="DL Expiry Date"
								type="date"
								v-model="drivingLicense.expiryDate"
								class="form-control form-control-lg dashInput"
								rules="required"
							/>
						</div>
					</div>
					<div v-if="data.identityProof === 'Passport'" class="row">
						<div class="form-group col-sm-3 mb-4">
							<BaseInput
								name="Passport Number"
								label="Passport Number"
								type="text"
								v-model="passport.number"
								class="form-control form-control-lg dashInput"
								rules="required|min:3"
							/>
						</div>

						<div class="form-group col-sm-3 mb-4">
							<BaseInput
								name="Passport Issue Date"
								label="Passport Issue Date"
								type="date"
								v-model="passport.issueDate"
								class="form-control form-control-lg dashInput"
								rules="required"
							/>
						</div>
						<div class="form-group col-sm-3 mb-4">
							<BaseInput
								name="Passport Issue Date"
								label="Passport Issue Date"
								type="date"
								v-model="passport.issueDate"
								class="form-control form-control-lg dashInput"
								rules="required"
							/>
						</div>
					</div>

					<div
						class="col-sm-12 col-md-12 col-ls-12 mt-sm-4 mb-sm-4 mt-md-2 mb-md-2 mt-lg-4 mb-lg-4"
					>
						<div class="form-group">
							<div class="form-check form-switch mt-2 mb-4">
								<input
									class="form-check-input"
									v-model="profileDocument"
									type="checkbox"
									id="imageCheck"
								/>
								<label class="form-check-label text-dark" for="imageCheck"
									>Upload Customer Profile image</label
								>
							</div>
						</div>
					</div> -->

					<div class="form-group col-sm-12 mt-4">
						<BaseButton
							class="btn bg-blue text-white form-control"
							type="submit"
							label="Save"
						/>
					</div>
				</div>
			</form>
		</section>
	</div>
</template>
<script>
	import { reactive, ref, inject } from "vue";

	import API from "@/config/api";
	import toast from "@/config/toast";
	import Helper from "@/helpers/dataHelper";
	import BaseInput from "./BaseInput.vue";
	import BaseButton from "./BaseButton.vue";
	import BaseRadio from "./BaseRadio.vue";
	import BaseMultiSelect from "./BaseMultiSelect.vue";
	import BaseImageUpload from "./BaseImageUpload.vue";

	export default {
		name: "CustomerEdit",
		components: {
			BaseInput,
			BaseButton,
			BaseRadio,
			BaseMultiSelect,
			BaseImageUpload,
		},
		props: [],

		setup: () => {
			const masterStore = inject("masterStore");

			const data = reactive({
				phone: null,
				email: null,
				salutation: null,
				firstName: null,
				lastName: null,
				loc: null,
				city: null,
				alternatePhone: null,
				alternateEmail: null,
				customerType: null,
				addressOne: null,
				postalCode: null,
				alternateAddress: null,
				alternatePhoneOne: null,
				alternatePhoneTwo: null,
				tags: [],
				identityProof: null,
				profile: null,
				dateOfBirth: null,
				anniversary: null,
				document: null,
			});

			const panCard = ref("");
			const passport = reactive({ number: "", issueDate: "", expiryDate: "" });
			const drivingLicense = reactive({
				number: "",
				issueDate: "",
				expiryDate: "",
			});
			const aadharCard = ref("");
			const imageDocument = ref(false);
			const imageProfile = ref(false);
			const profileDocument = ref(false);

			const multiSelectState = reactive({
				tags: [],
				tagsSelect: [],
				customerType: Helper.customerType,
				salutations: Helper.salutations,
			});

			const setImage = (images) => {
				if (!images.length) return;
				data.document = images[images.length - 1];
				formState.disable = false;
			};

			const setTag = (payload) => {
				data.tags = [...payload];
			};

			const setSalutation = (value) => {
				data.salutation = value;
			};

			const setCustomerType = (payload) => {
				data.customerType = payload;
			};

			const createCustomer = async () => {
				try {
					
					await API.privateRequest.patch(
						`customers/${masterStore.state.data._id}`,
						data,
					);
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}

					toast.error(message, true);
				}
			};

			const getTags = async () => {
				try {
					const response = await API.privateRequest.get("tags");
					const changedTags = response.data.data.map((tag) => ({
						value: tag._id,
						label: tag.name,
					}));
					multiSelectState.tags = response.data.data;
					multiSelectState.tagsSelect = changedTags;
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}

					toast.error(message, true);
				}
			};

			getTags();

			//! setting state
			if (
				masterStore?.state?.data &&
				Object.keys(masterStore?.state?.data).length
			) {
				Object.keys(data).map(
					(key) => (data[key] = masterStore.state.data[key] || data[key]),
				);
				data.salutation = masterStore.state.data?.name?.salutation;
				data.firstName = masterStore.state.data?.name?.firstName;
				data.lastName = masterStore.state.data?.name?.lastName;
				data.loc = masterStore.state.data?.address?.loc;
				data.city = masterStore.state.data?.address?.city;
				data.dateOfBirth = masterStore.state.data.dateOfBirth
					? masterStore.state.data.dateOfBirth.split("T")[0]
					: null;
				data.anniversary = masterStore.state.data.anniversary
					? masterStore.state.data.anniversary.split("T")[0]
					: null;
			}
			return {
				data,
				panCard,
				passport,
				drivingLicense,
				aadharCard,
				imageDocument,
				imageProfile,
				profileDocument,
				multiSelectState,
				setImage,
				setTag,
				setSalutation,
				setCustomerType,
				createCustomer,
			};
		},
	};
</script>